import { render, staticRenderFns } from "./UploadAnexos.vue?vue&type=template&id=71d8be58&scoped=true&lang=pug&"
import script from "./UploadAnexos.vue?vue&type=script&lang=js&"
export * from "./UploadAnexos.vue?vue&type=script&lang=js&"
import style0 from "./UploadAnexos.vue?vue&type=style&index=0&id=71d8be58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8be58",
  null
  
)

export default component.exports